/**
 * Runs MathJax on dynamically inserted HTML (marked output). Chat v1 (AIRAMessage)
 * already did this inline; v2 MarkdownMessage / V2Markdown must call this after innerHTML updates.
 */
export function typesetMathInElement(root: HTMLElement | null): void {
  if (!root || typeof window === 'undefined') return
  const mj = (window as unknown as { MathJax?: { typesetPromise?: (nodes: HTMLElement[]) => Promise<void> } })
    .MathJax
  if (!mj?.typesetPromise) return
  void mj.typesetPromise([root]).catch((err: unknown) => {
    console.warn('MathJax typeset failed:', err)
  })
}
